import { Box } from '@chakra-ui/react'
import { Button, StandardLayout } from '@sequencehq/core-components'
import { useSelectedCurrency } from '../utils/useSelectedCurrency'
import { ExportCSVModal } from '../common/ExportCSVModal'
import { ArrowDownTrayIcon } from '@heroicons/react/16/solid'
import { useSelectedDateRange } from '../utils/useSelectedDateRange'
import { useSearchParams } from 'react-router-dom'

export const RevenueRecognitionDashboardHeader = () => {
  const { currency } = useSelectedCurrency()
  const { dateRange } = useSelectedDateRange()

  const [searchParams] = useSearchParams()
  const customerIds = searchParams.get('customerId')
  const productIds = searchParams.get('productId')

  return (
    <Box>
      <StandardLayout.Header
        title="Revenue recognition"
        actions={
          !!currency && (
            <ExportCSVModal
              from={dateRange[0]}
              to={dateRange[1]}
              currency={currency}
              customerIds={customerIds ? customerIds.split(',') : undefined}
              productIds={productIds ? productIds.split(',') : undefined}
              trigger={
                <Button
                  variant="secondary"
                  leadingIcon={<ArrowDownTrayIcon width="16px" />}
                  data-testid="revrec.detail.exportCSV"
                >
                  Export to CSV
                </Button>
              }
            />
          )
        }
      />
    </Box>
  )
}
